import { ImageUploaderState } from "../../types";

export const hideModal = (state: ImageUploaderState) => {
    state.invalidImageExtensionModal = {
        isOpen: false,
        allowedExts: [],
        invalidExts: [],
    };
};
